module.exports = __webpack_public_path__ + "img/gr.71452bbd.svg";